export enum UserStatus {
  DEACTIVATED = 0, // Also, newly invited to join
  ACTIVE, // Also, finished registration
  BLOCKED,
  APPROVED,
}
